import {createAnatomy} from '@zag-js/anatomy';

export const anatomy = createAnatomy(`bar-chart`).parts(`container`, `tooltip`, `bar`, `tick`);

export const parts = anatomy.build();

export type Part = keyof typeof parts;
